<template>
  <div class="grid md:grid-cols-1 gap-7 pt-8 md:pt-0 h-screen px-8">
    <div class="flex flex-col content-center justify-center h-full w-full">
      <div class="text-center">
        <h2 class="font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
          Oops.. Page Not Found
        </h2>
        <router-link :to="{ name: 'Home'}" class="inline-flex hover:text-gray-400 mt-4 text-indigo-400 items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800">Back TO home Page
          <svg class="inline-block w-3 ml-2" fill="currentColor" viewBox="0 0 12 12">
            <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z"></path>
          </svg>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "404.vue"
}
</script>